// extracted by mini-css-extract-plugin
module.exports = {"button":"CompteFactures_button__1ef4G"};